import React from 'react';
import { Text, StyleSheet } from '@react-pdf/renderer';
import { PDF_FONTS } from '../pdfTypography';

const styles = StyleSheet.create({
  text: {
    fontSize: PDF_FONTS.body,
    color: '#000000',
    lineHeight: 2,
    marginBottom: 10,
  },
});

interface ParagraphProps {
  children: string;
}

const Paragraph: React.FC<ParagraphProps> = ({ children }) => (
  <Text style={styles.text}>{children}</Text>
);

export default Paragraph;
